export interface SelfServeCandidate {
  is_custom?: boolean | null;
  billing_mode?: string | null;
}

export function isSelfServePlan(plan: SelfServeCandidate | null | undefined): boolean {
  return Boolean(plan) && plan?.is_custom !== true && plan?.billing_mode !== "per_use";
}
